import React from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import useAuth from 'components/Auth/useAuth';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
}));

export default function PaperExpired(props)
{
  const classes = useStyles();
  const auth = useAuth();

  return(
    <Grid className={classes.container} container justifyContent="center">
      <Paper className={classes.paper}>
        <Typography>閲覧の有効期限が切れています。</Typography>
        <Typography>
        {
          auth.isLocked ? 
            "PlusNaviの画面から再度表示してください。" : 
          auth.isCustomer ? 
            "StaffNavigartor, CastingNaviから再度表示してください。" :
            "閲覧するためには、ログインしてください。"
        }
        </Typography>
      </Paper>
    </Grid>
  );
}